<template>
  <div>
    <select-condition style="margin-bottom: 30px" />
    <select-result />
  </div>
</template>

<script>
import SelectCondition from '../SelectCondition'
import SelectResult from '../SelectResult'
export default {
  name: 'PersonPolicy',
  components: { SelectCondition, SelectResult },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
